import cx from 'classnames';
import * as React from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide, type SwiperProps } from 'swiper/react';

import { Arrow } from './parts/Arrow';
import * as styles from './styles.css';
import './swiper.css';

const modules = [Navigation];

export interface ICarouselProps extends SwiperProps {
  className?: string;
  testId?: string;
  children: React.ReactElement[];
}

export const Carousel: React.FC<React.PropsWithChildren<ICarouselProps>> = props => {
  const { children, testId, className, ...swiperOptions } = props;

  // Элементы навигации храним в state, а не в ref: на первом рендере их ещё нет (null),
  // и swiper инициализирует навигацию без них. После маунта setState вызывает ре-рендер,
  // на котором swiper/react сам увидит новые prevEl/nextEl и доинициализирует навигацию
  // (см. needNavigationInit в swiper/shared/update-swiper.mjs).
  const [prevEl, setPrevEl] = React.useState<HTMLDivElement | null>(null);
  const [nextEl, setNextEl] = React.useState<HTMLDivElement | null>(null);

  const disabledClass = `${className}-button-disabled`;

  return (
    <div className={cx(styles['wrapper'], `${className}_wrapper`)} data-testid={testId}>
      <div className={styles['container']}>
        <Swiper
          modules={modules}
          navigation={{
            prevEl,
            nextEl,
            disabledClass,
          }}
          {...swiperOptions}
        >
          {React.Children.map(children, (child, index) => (
            <SwiperSlide key={index}>{child}</SwiperSlide>
          ))}
        </Swiper>
      </div>
      {swiperOptions.slidesPerView &&
        typeof swiperOptions.slidesPerView === 'number' &&
        React.Children.count(children) > swiperOptions.slidesPerView && (
          <>
            {/* Карусель всегда стартует с первого слайда, поэтому в SSR-разметке и до
                инициализации навигации левая стрелка сразу скрыта disabled-классом.
                Дальше этим классом управляет swiper (navigation.update). */}
            <Arrow direction={-1} ref={setPrevEl} className={disabledClass} />
            <Arrow direction={1} ref={setNextEl} />
          </>
        )}
    </div>
  );
};

Carousel.displayName = 'Carousel';

// oxlint-disable-next-line import/no-default-export
export default Carousel;
